'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _isEmpty2 = require('ramda/src/isEmpty');

var _isEmpty3 = _interopRequireDefault(_isEmpty2);

var _has2 = require('ramda/src/has');

var _has3 = _interopRequireDefault(_has2);

var _find2 = require('ramda/src/find');

var _find3 = _interopRequireDefault(_find2);

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactFinalFormArrays = require('react-final-form-arrays');

var _experiumPlayerHelpersLegacy = require('experium-player-helpers-legacy');

var _SelectTypeField = require('./SelectTypeField');

var _SelectTypeField2 = _interopRequireDefault(_SelectTypeField);

var _InputTypeField = require('./InputTypeField');

var _InputTypeField2 = _interopRequireDefault(_InputTypeField);

var _MatrixTypeField = require('./MatrixTypeField');

var _MatrixTypeField2 = _interopRequireDefault(_MatrixTypeField);

var _DefaultTypeField = require('./DefaultTypeField');

var _DefaultTypeField2 = _interopRequireDefault(_DefaultTypeField);

var _platform = require('./platform');

var _Table = require('./Table');

var _Table2 = _interopRequireDefault(_Table);

var _getButtons = require('../utils/getButtons');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var formComponentTypes = [{ type: 'select', component: _SelectTypeField2.default }, { type: 'input', component: _InputTypeField2.default }, { type: 'matrix', component: _MatrixTypeField2.default }];

var Page = function (_Component) {
    _inherits(Page, _Component);

    function Page() {
        _classCallCheck(this, Page);

        return _possibleConstructorReturn(this, (Page.__proto__ || Object.getPrototypeOf(Page)).apply(this, arguments));
    }

    _createClass(Page, [{
        key: 'getFormComponent',
        value: function getFormComponent(item, key) {
            var _props = this.props,
                options = _props.options,
                viewMode = _props.viewMode,
                language = _props.language;

            var componentType = (0, _find3.default)(function (_ref) {
                var type = _ref.type;
                return (0, _has3.default)(type, item);
            }, formComponentTypes);
            var Component = componentType ? componentType.component : _DefaultTypeField2.default;
            var components = componentType ? _platform.formComponents[componentType.type] : _platform.formComponents.default;

            return _react2.default.createElement(Component, {
                key: key,
                item: item,
                language: language,
                vertical: options.columns === '1',
                components: components,
                viewMode: viewMode
            });
        }
    }, {
        key: 'renderTable',
        value: function renderTable(item, key, index) {
            var _this2 = this;

            return _react2.default.createElement(
                _reactFinalFormArrays.FieldArray,
                { key: key, name: 'table-' + this.props.pageNumber + '-' + index },
                function (_ref2) {
                    var fields = _ref2.fields;
                    return _react2.default.createElement(
                        _Table2.default,
                        { fields: fields },
                        function (name) {
                            return _this2.renderComponents(item.items, name);
                        }
                    );
                }
            );
        }
    }, {
        key: 'renderComponents',
        value: function renderComponents() {
            var _this3 = this;

            var items = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props.page.items;
            var table = arguments[1];

            return (items || []).map(function (item, index) {
                item = table ? _extends({}, item, { id: table + '.' + item.id }) : item;
                var key = 'field-' + (item.id || index);

                return item.id ? _this3.getFormComponent(item, key) : item.type === 'table' ? _this3.renderTable(item, key, index) : _react2.default.createElement(_platform.textComponents[item.type], {
                    text: (0, _experiumPlayerHelpersLegacy.getText)(item, _this3.props.language),
                    item: item,
                    key: key
                });
            });
        }
    }, {
        key: 'render',
        value: function render() {
            var btns = (0, _getButtons.getButtons)(this.props.options);
            var buttons = this.props.viewMode ? this.props.pagesCount > 1 ? btns : {} : btns;

            return _react2.default.createElement(
                _platform.Container,
                { style: this.props.style, hasButtons: !(0, _isEmpty3.default)(buttons) },
                this.renderComponents()
            );
        }
    }]);

    return Page;
}(_react.Component);

Page.propTypes = {
    page: _propTypes2.default.object,
    options: _propTypes2.default.object,
    viewMode: _propTypes2.default.bool,
    style: _propTypes2.default.string,
    pageNumber: _propTypes2.default.number,
    language: _propTypes2.default.string,
    pagesCount: _propTypes2.default.number
};
Page.defaultProps = {
    style: ''
};
exports.default = Page;